export const SECURITY_URL = 'https://jitsi.org/security/';
const ROOM = {
    LIMITED: "LIMITED"
};
const USER = {
    REFRESHING: 'refreshing',
    TOKEN: 'token',
    ROLE: {
        TMP_GUEST: 'tmp_guest'
    }
};
export const EVENT_ACTIONS = {
    ENTER_PRESS: 'Enter'
};
export { ROOM, USER };
